import React, { useEffect, Fragment, } from 'react';
import { FormGroup, Label, Input, Button, Modal, ModalBody, ModalFooter, Form, } from 'reactstrap';
import { sumBy, isArray, chunk, orderBy, isEmpty, keyBy, omit, mapValues, } from 'lodash';
import { useToggle, useList, } from 'react-use';
import Select, { components, } from 'react-select';
import { jsPDF } from 'jspdf';
import { PDFDocument, } from 'pdf-lib';
import fileDownload from 'js-file-download';

import useFormState from '../hooks/useFormState';
import { idWithTenant, } from '../../shared/util';
import { isMobile, } from '../../util';
import useCollectionSubscription from '../hooks/useCollectionSubscription';
import { drawProductLabels24, drawProductLabels40, } from '../../label';
import Field from '../Field';
import { fields as _fields, itemFields as _itemFields, adminFields, pendingItemFields, adminItemFields,} from '../../shared/models/receivingRequest';
import ListForm from '../ListForm';
import ProductSelectOptionLabel from '../ProductSelectOptionLabel';
import PendingItemForm from '../forms/PendingItemForm';
import MenuList from '../MenuList';
import receivingRequestIdImage from '../../images/inspect_types/receiving_request_id.jpg';
import tenantIdImage from '../../images/inspect_types/tenant_id.jpg';
import productIdImage from '../../images/inspect_types/product_id.jpg';

const { keys, entries, } = Object;
const scale = 10;

export default function ReceivingRequestFormModal(props) {
  const { itemRef, isOpen, values, tenant, newProductId, onClickClose, admin = false, renderFormBody = _ => _, renderFooterContent = _ => _, } = props;
  const originalItems = values?.items || [];
  const originalItemByProductId = keyBy(originalItems, 'productId');
  const productChunks = useCollectionSubscription(tenant.ref.collection('productChunks'), [tenant.id]);
  // セット品は実在庫を持たないため入荷させない
  const products = productChunks.flatMap(_ => entries(omit(_, ['id', 'ref'])).map(([k, v]) => ({ id: k, ref: tenant.ref.collection('products').doc(k), ...v, }))).filter(_ => !_.hides && !_.isSet);
  const productsById = keyBy(products, 'id');
  const itemFields = admin ? adminItemFields : _itemFields;
  const isNew = !values || !values.id;

  // DEV
  // const [items, { set: setItems, updateAt: updateItemAt }] = useList(values.items || (newProductId ? [{ productId: newProductId, quantity: 1 }] : [{ productId: 22, quantity: 23 }, { productId: '86', quantity: 45 }]));
  const [items, { set: setItems, updateAt: updateItemAt }] = useList(values.items || (newProductId ? [{ productId: newProductId, quantity: 1 }] : [{ productId: null, quantity: 1 }]));
  const totalItemsCount = sumBy(items, 'quantity');

  const [pendingItems, { set: setPendingItem, updateAt: updatePendingItemAt }] = useList(values.pendingItems || []);
  const fields = admin ? adminFields({ values }) : _fields({ items, tenant, productsById, });
  const statedFields = useFormState(values, fields, isOpen);
  const isUnsubmittable =
    Object.values(statedFields).some(_ => !_.isValid) ||
    totalItemsCount > 5000 ||
    items.length === 0 ||
    items.some(_ => !_.isValid) ||
    (admin && pendingItems.some(_ => !_.isValid));
  const onSubmit = async (event) => {
    event.preventDefault();
    if(isUnsubmittable) return;

    await props.onSubmit({ ...mapValues(statedFields, 'value'), items: items.map(_ => ({ ...originalItemByProductId[_.productId], ...omit(_, 'isValid') })), pendingItems: pendingItems.map(_ => omit(_, 'isValid')), });
  };
  const unitItems = items.map(item => Array(item.quantity || 0).fill().map(_ => ({ product: productsById[item.productId] }))).flat();
  const onClickDownloadLabel = async (type, _items) => {
    const allPdfDoc = await PDFDocument.create();
    const items = isArray(_items) ? _items : ({
      id: unitItems,
      fnsku: unitItems.filter(_ => _.product?.isAmazonProduct && !_.product?.isCase),
      mix: unitItems,
    })[type];
    await chunk(items, ({ label40: 40, label1: 1 })[tenant.labelPdfType || 'label40']).reduce(async (x, items, i) => {
      await x;

      const canvas = document.createElement('canvas');
      let doc;
      ({
        label40: () => {
          canvas.width = scale * 210;
          canvas.height = scale * 297;
          drawProductLabels40(canvas, items, scale, type);
          const imageData = canvas.toDataURL('image/jpeg', 0.9);
          doc = new jsPDF({
            format: [210, 297]
          });
          doc.addImage(imageData, 'JPEG', 0, 0, 210, 297);
        },
        label1: () => {
          canvas.width = scale * 52.5;
          canvas.height = scale * 29.7;
          drawProductLabels40(canvas, items, scale, type);
          const imageData = canvas.toDataURL('image/jpeg', 0.9);
          doc = new jsPDF({
            orientation: 'landscape',
            format: [52.5, 29.7]
          });
          doc.addImage(imageData, 'JPEG', 0, 0, 52.5, 29.7);
        },
      })[tenant.labelPdfType || 'label40']();
      const pdfData = doc.output('datauri');
      const pdfDoc = await PDFDocument.load(pdfData);
      const [page] = await allPdfDoc.copyPages(pdfDoc, keys(pdfDoc.getPages()));
      await allPdfDoc.addPage(page);
    }, Promise.resolve());
    fileDownload(await allPdfDoc.save(), `${idWithTenant(itemRef)}_${({ id: '商品ラベル', fnsku: 'Amazonラベル', mix: '混合ラベル', })[type]}.pdf`);
  };

  // DEV
  //  useEffect(() => {
  //    if(!isEmpty(productsById)) {
  //      const canvas = document.getElementById('canvas');
  //      drawProductLabels24(canvas, unitItems.slice(0, 24), 3);
  //    }
  //  }, [productsById]);

  // DEV
  //  useEffect(() => {
  //    if(!isEmpty(productsById)) {
  //      const canvas = document.getElementById('canvas');
  //      drawProductLabels40(canvas, unitItems.slice(0, 40), 3, 'mix');
  //    }
  //  }, [productsById]);


  return (
    <Modal isOpen={isOpen} style={{ minWidth: !isMobile() && 800 }}>
      <div className="modal-header">
        <div className="w-100 d-flex justify-content-between">
          <h5 className="modal-title">
            入荷依頼{isNew ? '追加' : '編集'}
          </h5>
        </div>
      </div>
      <Form onSubmit={onSubmit}>
        <ModalBody>
          {
            // DEV
            // <canvas className="border" id="canvas" width={210 * 3} height={297 * 3} />
          }
          {
            renderFormBody((
              <Fragment>
                <div>
                  <ListForm
                    initialItem={_ => ({ quantity: 1 })}
                    addButtonLabel="商品追加"
                    items={items}
                    renderItem={(item, itemIndex) => {
                      return (
                        <div className="card p-3">
                          <ItemForm
                            fields={itemFields({ items, products, productsById, })}
                            index={itemIndex}
                            values={item}
                            product={productsById[item.productId]}
                            products={products}
                            tenant={tenant}
                            onChange={_ => updateItemAt(itemIndex, { ...item, ..._, })}
                            admin={admin}
                            onClickDownloadLabel={onClickDownloadLabel}
                          />
                        </div>
                      );
                    }}
                    onChange={setItems}
                    minItems={1}
                    disabled={admin}
                    renderFooterContent={(base) => {
                      return (
                        <div className="d-flex gap-1 align-items-start">
                          {base}
                          <div>
                            <div className="d-flex gap-1">
                              <Button onClick={onClickDownloadLabel.bind(null, 'id')} disabled={items.some(_ => !_.productId)}>
                                <span className="fas fa-download mr-1" />
                                商品ラベル
                              </Button>
                              <Button onClick={onClickDownloadLabel.bind(null, 'fnsku')} disabled={items.some(_ => !_.productId) || unitItems.some(_ => _.product?.isAmazonProduct && !_.product?.isCase && _.product?.fnsku == null)}>
                                <span className="fas fa-download mr-1" />
                                Amazonラベル
                              </Button>
                              <Button onClick={onClickDownloadLabel.bind(null, 'mix')} disabled={items.some(_ => !_.productId) || unitItems.some(_ => _.product?.isAmazonProduct && !_.product?.isCase && _.product?.fnsku == null)}>
                                <span className="fas fa-download mr-1" />
                                混合ラベル
                              </Button>
                            </div>
                            <div className="text-muted small mt-1 d-none">
                              ラベルサイズは【66×33.9mm(3列×8段) 24面】をご利用ください。
                            </div>
                            <div className="text-muted small mt-1">
                              ラベルサイズは【52.5×29.7mm(4列×10段) 40面】をご利用ください。
                            </div>
                          </div>
                        </div>
                      );
                    }}
                  />
                  {
                    totalItemsCount > 5000 && (
                      <div className="alert alert-danger">
                        1つの入荷依頼に登録できる商品点数は最大5,000点までです。入荷依頼をわけて登録してください。
                      </div>
                    )
                  }
                </div>
                {
                  admin && (
                    <div className="mt-3 card p-3">
                      <ListForm
                        addButtonLabel="不明・確認在庫 追加"
                        items={pendingItems}
                        renderItem={(pendingItem, pendingItemIndex) => {
                          return (
                            <div className="card p-3">
                              <PendingItemForm
                                fields={pendingItemFields()}
                                index={pendingItemIndex}
                                values={pendingItem}
                                onChange={_ => updatePendingItemAt(pendingItemIndex, { ...pendingItem, ..._, })}
                              />
                            </div>
                          );
                        }}
                        onChange={setPendingItem}
                      />
                    </div>
                  )
                }
                <div className="mt-3">
                  {
                    entries(statedFields).map(([fieldName, fieldSetting]) => {
                      return (
                        <Fragment>
                          <Field
                            key={fieldName}
                            name={fieldName}
                            documentName="receivingRequest"
                            {...fieldSetting}
                          />
                        </Fragment>
                      )
                    })
                  }
                  <div className="text-danger font-weight-bold mb-4">
                    <div>
                      <div>※【ユーザーID】を送り状住所末尾に記載してください。</div>
                    </div>
                  </div>
                </div>
                {
                  isNew && (
                    <div>
                      <div className="alert alert-danger">
                        ※倉庫へ商品をお送りする際の宛名と電話番号はお客様ご自身のものをご記載ください。<br />
                        ※１伝票番号につき、１入荷IDをご記載下さい。<br />
                      </div>
                    </div>
                  )
                }
              </Fragment>
            ))
          }
        </ModalBody>
        <ModalFooter>
          {
            renderFooterContent((
              <Fragment>
                <Button className="cancel" color="secondary" onClick={onClickClose}>閉じる</Button>
                <Button className="save" type="submit" color="primary" onClick={onSubmit} disabled={isUnsubmittable}>保存</Button>
              </Fragment>
            ), { items, onSubmit, isUnsubmittable, })
          }
        </ModalFooter>
      </Form>
    </Modal>
  );
};

function ItemForm (props) {
  const { index: itemIndex, fields, values, tenant, product, onChange, admin = false, products, onClickDownloadLabel, } = props;
  const statedFields = useFormState(values, fields, values);
  useEffect(() => {
    onChange({
      ...mapValues(statedFields, 'value'),
      isValid: Object.values(statedFields).every(_ => _.isValid),
    });
  }, [...Object.values(statedFields).map(_ => _.value), ...Object.values(statedFields).map(_ => _.isValid)]);
  const productOptions = products.map((product) => {
    const { id, ref, sku, code, name, asin, fnsku, barcodeInfo, } = product;
    return {
      value: id,
      queryLabel: [id, name, sku, code, asin, fnsku, barcodeInfo].join(' '),
      label: (
        <ProductSelectOptionLabel product={product} />
      ),
    };
  });

  return (
    <div>
      {
        admin && product != null && (
          <div className="small mb-2">
            <div>
              [{tenant.id}-{product.id}] ({product.sku}) {product.name}
            </div>
            <div>
              {values.quantity}個
            </div>
          </div>
        )
      }
      {
        !admin && (
          <div className="d-flex flex-wrap gap-2">
            <div style={{ width: 500, }}>
              <Field
                name="productId"
                {...statedFields.productId}
                {...(itemIndex === 0 && { inputProps: { autoFocus: true, } })}
                {...{
                  options: productOptions,
                  inputProps: {
                    styles: { 
                      valueContainer: _ => ({ ..._, height: 60 }),
                      singleValue: _ => ({ ..._, top: 0, transform: '' }),
                    },
                    components: { MenuList },
                  },
                }}
              />
            </div>
            <div style={{ width: 154, }}>
              <Field
                name="quantity"
                className="m-0"
                {...statedFields.quantity}
              />
              <div className="mt-1 d-flex gap-1 justify-content-between">
                <Button className="text-nowrap" size="sm" onClick={onClickDownloadLabel.bind(null, 'id', Array(statedFields.quantity.value).fill({ product, }))}>
                  <span className="fas fa-download mr-1" />
                  LOGISP
                </Button>
                <Button className="text-nowrap" size="sm" onClick={onClickDownloadLabel.bind(null, 'fnsku', Array(statedFields.quantity.value).fill({ product, }))} disabled={!product?.isAmazonProduct || product?.isAmazonProduct && product?.isCase && product?.fnsku == null}>
                  <span className="fas fa-download mr-1" />
                  Amazon
                </Button>
              </div>
            </div>
          </div>
        )
      }
    </div>
  );
}
